module.exports = __webpack_public_path__ + "img/logo_qcc.8b71e028.png";